module.exports = __webpack_public_path__ + "img/games-23.f9cf8524.webp";